export const generalFieldList = [{
    key: 'general-ContractNo',
    name: 'System Contract No.',
    templatePreview: '{System Contract No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.contractNo',
}, {
    key: 'general-CustomContractNo',
    name: 'Custom Contract No.',
    templatePreview: '{Custom Contract No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.customContractNo',
    specifySide: ['agency'],
}, {
    key: 'general-ECNo',
    name: 'EC No.',
    templatePreview: '{EC No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ecNo',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'general-CaseType',
    name: 'Case Type',
    templatePreview: '{Case Type}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'generalInfo.contractType',
    specifySide: ['agency'],
}, {
    key: 'general-Admin',
    name: 'Admin',
    templatePreview: '{Admin}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'generalInfo.adminName',
    idProperty: 'generalInfo.adminId',
    specifySide: ['agency'],
}, {
    key: 'general-EAPersonnel',
    name: 'EA Personnel',
    templatePreview: '{EA Personnel}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'generalInfo.salesPerson',
    idProperty: 'generalInfo.salesPersonId',
    specifySide: ['agency'],
}, {
    key: 'general-Salesperson',
    name: 'Salesperson',
    templatePreview: '{Salesperson}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'generalInfo.marketSalesPerson',
    idProperty: 'generalInfo.marketSalesId',
    specifySide: ['agency'],
}, {
    key: 'general-EARegistrationNo',
    name: 'EA Registration No.',
    templatePreview: '{EA Registration No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.registrationNo',
    specifySide: ['agency'],
}, {
    key: 'general-IPAAgencyName',
    name: 'IPA Agency Name',
    templatePreview: '{IPA Agency Name}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyName',
    specifySide: ['agency'],
}, {
    key: 'general-IPAAgencyLicenseNo',
    name: 'IPA Agency License No.',
    templatePreview: '{IPA Agency License No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyLicenseNo',
    specifySide: ['agency'],
}, {
    key: 'general-IPAAgencyUEN',
    name: 'IPA Agency UEN',
    templatePreview: '{IPA Agency UEN}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyUen',
    specifySide: ['agency'],
}, {
    key: 'general-IPAAgencyContactNumber',
    name: 'IPA Agency Contact Number',
    templatePreview: '{IPA Agency Contact Number}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyPhoneNumber',
    specifySide: ['agency'],
}, {
    key: 'general-IPAAgencyAddress',
    name: 'IPA Agency Address',
    templatePreview: '{IPA Agency Address}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyAddress',
    specifySide: ['agency'],
}, {
    key: 'general-IPAAgencyEAPersonnel',
    name: 'IPA Agency EA Personnel',
    templatePreview: '{IPA Agency EA Personnel}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyEaPersonal',
    specifySide: ['agency'],
}, {
    key: 'general-IPAAgencyEARegistrationNo',
    name: 'IPA Agency EA Registration No.',
    templatePreview: '{IPA Agency EA Registration No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyEaRegistrationNo',
    specifySide: ['agency'],
}, {
    key: 'general-PHAgencyName',
    name: 'PH Agency Name',
    templatePreview: '{PH Agency Name}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.phAgencyName',
    specifySide: ['agency'],
}, {
    key: 'general-PHAgencyAddress',
    name: 'PH Agency Address',
    templatePreview: '{PH Agency Address}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.phAgencyAddress',
    specifySide: ['agency'],
}, {
    key: 'general-PHAgencyContactNumber',
    name: 'PH Agency Contact Number',
    templatePreview: '{PH Agency Contact Number}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.phAgencyPhoneNumber',
    specifySide: ['agency'],
}, {
    key: 'general-PHAgencyDirector',
    name: 'PH Agency Director',
    templatePreview: '{PH Agency Director}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.phAgencyDirectorName',
    specifySide: ['agency'],
}, {
    key: 'general-PHAgencyLicenseNo',
    name: 'PH Agency License No.',
    templatePreview: '{PH Agency License No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.phAgencyLicenseNo',
    specifySide: ['agency'],
}, {
    key: 'general-EmploymentAgencyName',
    name: 'Employment Agency Name',
    templatePreview: '{Employment Agency Name}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.employmentAgencyName',
    specifySide: ['agency'],
}, {
    key: 'general-EmploymentAgencyLicenseNo',
    name: 'Employment Agency License No.',
    templatePreview: '{Employment Agency License No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.employmentAgencyLicenseNo',
    specifySide: ['agency'],
}, {
    key: 'general-EmploymentAgencyUEN',
    name: 'Employment Agency UEN',
    templatePreview: '{Employment Agency UEN}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.employmentAgencyUen',
    specifySide: ['agency'],
}, {
    key: 'general-EmploymentAgencyContactNumber',
    name: 'Employment Agency Contact Number',
    templatePreview: '{Employment Agency Contact Number}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.employmentAgencyContactNumber',
    specifySide: ['agency'],
}, {
    key: 'general-EmploymentAgencyAddress',
    name: 'Employment Agency Address',
    templatePreview: '{Employment Agency Address}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.employmentAgencyAddress',
    specifySide: ['agency'],
}, {
    key: 'general-RecruitmentAgencyName',
    name: 'Recruitment Agency Name',
    templatePreview: '{Recruitment Agency Name}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.phAgencyName',
    specifySide: ['supplier'],
}, {
    key: 'general-RecruitmentAgencyAddress',
    name: 'Recruitment Agency Address',
    templatePreview: '{Recruitment Agency Address}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.phAgencyAddress',
    specifySide: ['supplier'],
}, {
    key: 'general-RecruitmentAgencyContactNumber',
    name: 'Recruitment Agency Contact Number',
    templatePreview: '{Recruitment Agency Contact Number}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.phAgencyPhoneNumber',
    specifySide: ['supplier'],
}, {
    key: 'general-RecruitmentAgencyDirector',
    name: 'Recruitment Agency Director',
    templatePreview: '{Recruitment Agency Director}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.phAgencyDirectorName',
    specifySide: ['supplier'],
}, {
    key: 'general-RecruitmentAgencyLicenseNo',
    name: 'Recruitment Agency License No.',
    templatePreview: '{Recruitment Agency License No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.phAgencyLicenseNo',
    specifySide: ['supplier'],
}, {
    key: 'general-ProxyForeignPlacementAgencyName',
    name: 'Foreign Processing Service Agency Name',
    templatePreview: '{Foreign Processing Service Agency Name}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyName',
    specifySide: ['supplier'],
}, {
    key: 'general-ProxyForeignPlacementAgencyLicenseNo',
    name: 'Foreign Processing Service Agency License No.',
    templatePreview: '{Foreign Processing Service Agency License No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyLicenseNo',
    specifySide: ['supplier'],
}, {
    key: 'general-ProxyForeignPlacementAgencyContactNumber',
    name: 'Foreign Processing Service Agency Contact Number',
    templatePreview: '{Foreign Processing Service Agency Contact Number}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyPhoneNumber',
    specifySide: ['supplier'],
}, {
    key: 'general-ProxyForeignPlacementAgencyAddress',
    name: 'Foreign Processing Service Agency Address',
    templatePreview: '{Foreign Processing Service Agency Address}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyAddress',
    specifySide: ['supplier'],
}, {
    key: 'general-ProxyForeignPlacementAgencyEAPersonnelName',
    name: 'Foreign Processing Service Agency EA Personnel Name',
    templatePreview: '{Foreign Processing Service Agency EA Personnel Name}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyEaPersonal',
    specifySide: ['supplier'],
}, {
    key: 'general-ProxyForeignPlacementAgencyEARegistrationNo',
    name: 'Foreign Processing Service Agency EA Registration No.',
    templatePreview: '{Foreign Processing Service Agency EA Registration No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'generalInfo.ipaAgencyEaRegistrationNo',
    specifySide: ['supplier'],
}]

export const timelineFieldList = [{
    key: 'timeline-DateOfVerbalConfirmation',
    name: 'Date of Verbal Confirmation',
    templatePreview: '{Date of Verbal Confirmation}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'timelineInfo.confirmationDate',
    valueFormat: 'date',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'timeline-DateOfApplication',
    name: 'Date of Application',
    templatePreview: '{Date of Application}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'timelineInfo.ipaDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'timeline-DateOfIPAApproval',
    name: 'Date of IPA Approval',
    templatePreview: '{Date of IPA Approval}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'timelineInfo.ipaApprovalDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'timeline-ArrivalDate',
    name: 'Arrival Date',
    templatePreview: '{Arrival Date}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'timelineInfo.fdwArrivalDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'timeline-DateofBGINSSubmission',
    name: 'Date of BG/INS Submission',
    templatePreview: '{Date of BG/INS Submission}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'timelineInfo.bgInsSubmissionDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'timeline-DateofMedicalCheckUp',
    name: 'Date of Medical Check-up',
    templatePreview: '{Date of Medical Check-up}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'timelineInfo.medicalCheckDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'timeline-DateofSIP',
    name: 'Date of SIP',
    templatePreview: '{Date of SIP}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'timelineInfo.sipDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'timeline-DateofEIssue',
    name: 'Date of E-Issue',
    templatePreview: '{Date of E-Issue}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'timelineInfo.issueDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'timeline-DateOfDeployment',
    name: 'Date of Deployment',
    templatePreview: '{Date of Deployment}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'timelineInfo.deploymentDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'timeline-SalaryStartDate',
    name: 'Salary Start Date',
    templatePreview: '{Salary Start Date}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'timelineInfo.salaryStartDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'timeline-DateOfThumbprint',
    name: 'Date of Thumbprint',
    templatePreview: '{Date of Thumbprint}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'timelineInfo.thumbDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'timeline-MedicalCondition',
    name: 'Medical Condition',
    templatePreview: '{Medical Condition}',
    conditionType: 'char',
    property: 'timelineInfo.medicalCondition',
    specifySide: ['agency'],
}, {
    key: 'timeline-SBTransmissionNo',
    name: 'SB Transmission No.',
    templatePreview: '{SB Transmission No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'timelineInfo.sbTransmissionNo',
    specifySide: ['agency'],
}]

export const helperFieldList = [{
    key: 'helper-HelperID',
    name: 'Helper ID',
    templatePreview: '{Helper ID}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'helperInfo.helperPeanutId',
    specifySide: ['agency'],
}, {
    key: 'helper-HelperName',
    name: 'Helper Name (Legal)',
    templatePreview: '{Helper Name (Legal)}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'helperInfo.helperName',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'helper-HelperType',
    name: 'Helper Type',
    templatePreview: '{Helper Type}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'helperInfo.helperType',
    specifySide: ['agency'],
}, {
    key: 'helper-HelperWorkPermitNo',
    name: 'Helper Work Permit No.',
    templatePreview: '{Helper Work Permit No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'helperInfo.workPermitNumber',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'helper-HelperWorkPermitExpiryDate',
    name: 'Helper Work Permit Expiry Date',
    templatePreview: '{Helper Work Permit Expiry Date}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'helperInfo.workPermitExpiryDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'helper-HelperFINNo',
    name: 'Helper FIN No.',
    templatePreview: '{Helper FIN No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'helperInfo.finNumber',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'helper-HelperPassportNumber',
    name: 'Helper Passport Number',
    templatePreview: '{Helper Passport Number}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'helperInfo.helperPassportNumber',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'helper-HelperPassportExpiryDate',
    name: 'Helper Passport Expiry Date',
    templatePreview: '{Helper Passport Expiry Date}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'helperInfo.helperPassportExpiry',
    valueFormat: 'date',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'helper-PassportIssueDate',
    name: 'Passport Issue Date',
    templatePreview: '{Passport Issue Date}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'helperInfo.passportIssueDate',
    valueFormat: 'date',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'helper-PassportIssuePlace',
    name: 'Passport Issue Place',
    templatePreview: '{Passport Issue Place}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'helperInfo.passportIssuePlace',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'helper-HelperDateofBirth',
    name: 'Helper Date of Birth',
    templatePreview: '{Helper Date of Birth}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'helperInfo.helperBirthday',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'helper-PlaceofBirth',
    name: 'Place of Birth',
    templatePreview: '{Place of Birth}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'helperInfo.birthPlace',
    specifySide: ['agency'],
}, {
    key: 'helper-HelperReligion',
    name: 'Helper Religion',
    templatePreview: '{Helper Religion}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'helperInfo.helperReligionName',
    idProperty: 'helperInfo.religion',
    specifySide: ['agency'],
}, {
    key: 'helper-HelperEducationLevel',
    name: 'Helper Education Level',
    templatePreview: '{Helper Education Level}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'helperInfo.helperEducationLevelName',
    idProperty: 'helperInfo.educationLevel',
    specifySide: ['agency'],
}, {
    key: 'helper-HelperMaritalStatus',
    name: 'Helper Marital Status',
    templatePreview: '{Helper Marital Status}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'helperInfo.helperMaritalStatusName',
    idProperty: 'helperInfo.helperMaritalStatus',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'helper-HelperNationality',
    name: 'Helper Nationality',
    templatePreview: '{Helper Nationality}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'helperInfo.helperNationalityName',
    idProperty: 'helperInfo.helperNationalityId',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'helper-ResidentialAddressInHomeCountry',
    name: 'Residential address in home country',
    templatePreview: '{Residential address in home country}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'helperInfo.residentialAddress',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'helper-ContactNumberInHomecountry',
    name: 'Contact number in home country',
    templatePreview: '{Contact number in home country}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'helperInfo.telephoneNumber',
    specifySide: ['agency', 'supplier'],
}]

export const employerFieldList = [{
    key: 'employer-ApplicationType',
    name: 'Application Type',
    templatePreview: '{Application Type}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.applicationTypeName',
    idProperty: 'employerInfo.applicationType',
    specifySide: ['agency'],
}, {
    key: 'employer-ThisApplicationIsTo',
    name: 'This Application is to',
    templatePreview: '{This Application is to}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.applicationToName',
    idProperty: 'employerInfo.applicationTo',
    specifySide: ['agency'],
}, {
    key: 'employer-NameOfHelperReplaced',
    name: 'Name of helper replaced',
    templatePreview: '{Name of helper replaced}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.replaceHelperName',
    specifySide: ['agency'],
}, {
    key: 'employer-WPNoOfHelperReplaced',
    name: 'WP No. of helper replaced',
    templatePreview: '{WP No. of helper replaced}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.replaceHelperWp',
    specifySide: ['agency'],
}, {
    key: 'employer-IncomeUsing',
    name: 'Income Using',
    templatePreview: '{Income Using}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.incomeUseName',
    idProperty: 'employerInfo.incomeUse',
    specifySide: ['agency'],
}, {
    key: 'employer-MonthlyIncomeRange',
    name: 'Monthly Income Range (Combined)',
    templatePreview: '{Monthly Income Range (Combined)}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.monthSalaryMin',
    idProperty: 'employerInfo.monthSalaryMax',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-IncomeProof',
    name: 'Income Proof',
    templatePreview: '{Income Proof}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.incomeSupportDocName',
    idProperty: 'employerInfo.incomeSupportDoc',
    specifySide: ['agency'],
}, {
    key: 'employer-Occupation',
    name: 'Occupation',
    templatePreview: '{Occupation}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.employerOccupation',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-EmployerID',
    name: 'Employer ID',
    templatePreview: '{Employer ID}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.employerPeanutId',
    specifySide: ['agency'],
}, {
    key: 'employer-FullNameEmployer',
    name: 'Full Name(Legal)-Employer',
    templatePreview: '{Full Name(Legal)-Employer}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.employerName',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-FullNameChineseEmployer',
    name: 'Full Name(Chinese)-Employer',
    templatePreview: '{Full Name(Chinese)-Employer}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.employerNameLocal',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'employer-GenderEmployer',
    name: 'Gender-Employer',
    templatePreview: '{Gender-Employer}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.gender',
    specifySide: ['agency'],
}, {
    key: 'employer-DateOfBirthEmployer',
    name: 'Date of Birth-Employer',
    templatePreview: '{Date of Birth-Employer}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'employerInfo.employerBirthday',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'employer-NationalityEmployer',
    name: 'Nationality-Employer',
    templatePreview: '{Nationality-Employer}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.employerNationalityName',
    idProperty: 'employerInfo.employerNationalityId',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-ResidentialStatusEmployer',
    name: 'Residential Status-Employer',
    templatePreview: '{Residential Status-Employer}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.residentialName',
    idProperty: 'employerInfo.residential',
    specifySide: ['agency'],
}, {
    key: 'employer-NRICFINEmployer',
    name: 'NRIC / FIN-Employer',
    templatePreview: '{NRIC / FIN-Employer}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.nricFin',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-PassportNoEmployer',
    name: 'Passport No.-Employer',
    templatePreview: '{Passport No.-Employer}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.employerPassportNumber',
    specifySide: ['agency'],
}, {
    key: 'employer-PassportExpiryDateEmployer',
    name: 'Passport Expiry Date-Employer',
    templatePreview: '{Passport Expiry Date-Employer}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'employerInfo.employerPassportExpiry',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'employer-MaritalStatus',
    name: 'Marital Status',
    templatePreview: '{Marital Status}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.employerMaritalStatusName',
    idProperty: 'employerInfo.employerMaritalStatus',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-ContactNo',
    name: 'Contact No.',
    templatePreview: '{Contact No.}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.employerPhoneNumber',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-HousingType',
    name: 'Housing Type-Employer',
    templatePreview: '{Housing Type-Employer}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.houseTypeSpecialName',
    idProperty: 'employerInfo.houseType',
    specifySide: ['agency'],
}, {
    key: 'employer-EmailAddress',
    name: 'Email Address',
    templatePreview: '{Email Address}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.emailAddress',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-ResidentialAddress',
    name: 'Residential Address',
    templatePreview: '{Residential Address}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.residentialAddress',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-PostalCode',
    name: 'Postal Code',
    templatePreview: '{Postal Code}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.residentialPostalCode',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-FullNameSpouse',
    name: 'Full Name(Legal)-spouse',
    templatePreview: '{Full Name(Legal)-spouse}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.spouseName',
    specifySide: ['agency'],
}, {
    key: 'employer-GenderSpouse',
    name: 'Gender-spouse',
    templatePreview: '{Gender-spouse}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.spouseGender',
    specifySide: ['agency'],
}, {
    key: 'employer-DateOfBirthSpouse',
    name: 'Date of Birth-spouse',
    templatePreview: '{Date of Birth-spouse}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'employerInfo.spouseBirthday',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'employer-NationalitySpouse',
    name: 'Nationality-spouse',
    templatePreview: '{Nationality-spouse}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.spouseNationalityName',
    idProperty: 'employerInfo.spouseNationalityId',
    specifySide: ['agency'],
}, {
    key: 'employer-ResidentialStatusSpouse',
    name: 'Residential Status-spouse',
    templatePreview: '{Residential Status-spouse}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.spouseResidentialName',
    idProperty: 'employerInfo.spouseResidential',
    specifySide: ['agency'],
}, {
    key: 'employer-NRICFINSpouse',
    name: 'NRIC / FIN-spouse',
    templatePreview: '{NRIC / FIN-spouse}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.spouseNricFin',
    specifySide: ['agency'],
}, {
    key: 'employer-PassportNoSpouse',
    name: 'Passport No.-spouse',
    templatePreview: '{Passport No.-spouse}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.spousePassportNumber',
    specifySide: ['agency'],
}, {
    key: 'employer-PassportExpiryDateSpouse',
    name: 'Passport Expiry Date-spouse',
    templatePreview: '{Passport Expiry Date-spouse}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'employerInfo.spousePassportExpiry',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'employer-FamilyMemberName',
    name: 'Family Member Name',
    templatePreview: '{Family Member Name}',
    fieldType: 'system',
    renderType: 'table',
    property: 'employerInfo.familyMemberList',
    tableProperty: 'name',
    specifySide: ['agency'],
}, {
    key: 'employer-FamilyMemberIDType',
    name: 'Family Member ID Type',
    templatePreview: '{Family Member ID Type}',
    fieldType: 'system',
    renderType: 'table',
    property: 'employerInfo.familyMemberList',
    tableProperty: 'idType',
    specifySide: ['agency'],
}, {
    key: 'employer-FamilyMemberIDNo',
    name: 'Family Member ID No.',
    templatePreview: '{Family Member ID No.}',
    fieldType: 'system',
    renderType: 'table',
    property: 'employerInfo.familyMemberList',
    tableProperty: 'idNo',
    specifySide: ['agency'],
}, {
    key: 'employer-FamilyMemberDOB',
    name: 'Family Member D.O.B',
    templatePreview: '{Family Member D.O.B}',
    fieldType: 'system',
    renderType: 'table',
    property: 'employerInfo.familyMemberList',
    tableProperty: 'birthday',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'employer-FamlilyMemeberRelationship',
    name: 'Famlily Memeber Relationship',
    templatePreview: '{Famlily Memeber Relationship}',
    fieldType: 'system',
    renderType: 'table',
    property: 'employerInfo.familyMemberList',
    tableProperty: 'relationship',
    specifySide: ['agency'],
}, {
    key: 'employer-FamilySize0To20',
    name: 'Family Size（0-20y.o)',
    templatePreview: '{Family Size（0-20y.o)}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'employerInfo.familySizeFirstStage',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-FamilySize21To65',
    name: 'Family Size（21-65y.o)',
    templatePreview: '{Family Size（21-65y.o)}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'employerInfo.familySizeSecondStage',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-FamilySizeAbove65',
    name: 'Family Size（above 65y.o)',
    templatePreview: '{Family Size（above 65y.o)}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'employerInfo.familySizeThirdStage',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'employer-Sponsor1FullName',
    name: 'Sponsor1 Full Name',
    templatePreview: '{Sponsor1 Full Name}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.sponsor1.sponsorName',
    specifySide: ['agency'],
}, {
    key: 'employer-Sponsor1NRICFIN',
    name: 'Sponsor1 NRIC/FIN',
    templatePreview: '{Sponsor1 NRIC/FIN}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.sponsor1.sponsorNricFin',
    specifySide: ['agency'],
}, {
    key: 'employer-Sponsor1DOB',
    name: 'Sponsor1 D.O.B',
    templatePreview: '{Sponsor1 D.O.B}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'employerInfo.sponsor1.sponsorBirthday',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'employer-Sponsor1RelationshipToEmployer',
    name: 'Sponsor1 Relationship to Employer',
    templatePreview: '{Sponsor1 Relationship to Employer}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.sponsor1.sponsorRelationshipWithEmployer',
    specifySide: ['agency'],
}, {
    key: 'employer-Sponsor2FullName',
    name: 'Sponsor2 Full Name',
    templatePreview: '{Sponsor2 Full Name}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.sponsor2.sponsorName',
    specifySide: ['agency'],
}, {
    key: 'employer-Sponsor2NRICFIN',
    name: 'Sponsor2 NRIC/FIN',
    templatePreview: '{Sponsor2 NRIC/FIN}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'employerInfo.sponsor2.sponsorNricFin',
    specifySide: ['agency'],
}, {
    key: 'employer-Sponsor2DOB',
    name: 'Sponsor2 D.O.B',
    templatePreview: '{Sponsor2 D.O.B}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'employerInfo.sponsor2.sponsorBirthday',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'employer-Sponsor2RelationshipToEmployer',
    name: 'Sponsor2 Relationship to Employer',
    templatePreview: '{Sponsor2 Relationship to Employer}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'employerInfo.sponsor2.sponsorRelationshipWithEmployer',
    specifySide: ['agency'],
}]

export const jobOfferFieldList = [{
    key: 'jobOffer-BasicSalary',
    name: 'Basic Salary(in figures)',
    templatePreview: '{Basic Salary(in figures)}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.basicSalary',
    valueFormat: 'money',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-BasicSalaryWordInWords',
    name: 'Basic Salary(in words)',
    templatePreview: '{Basic Salary(in words)}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'jobOfferInfo.basicSalaryInWords',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-CompensationPerOffDay',
    name: 'Compensation Per Off Day',
    templatePreview: '{Compensation Per Off Day}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.compensationPerOffDay',
    valueFormat: 'money',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-TotalLoanAmount',
    name: 'Total Loan Amount',
    templatePreview: '{Total Loan Amount}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.amountLoan',
    specifySide: ['agency'],
}, {
    key: 'jobOffer-TotalSalaryLoanAmount',
    name: 'Total Salary Loan Amount',
    templatePreview: '{Total Salary Loan Amount}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.amountLoan',
    specifySide: ['supplier'],
}, {
    key: 'jobOffer-MonthlySalaryDeduction',
    name: 'Monthly Salary Deduction',
    templatePreview: '{Monthly Salary Deduction}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.monthlySalaryDeduction',
    valueFormat: 'money',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-RestDaysDuringLoanPeriod',
    name: 'Rest Days During Loan Period',
    templatePreview: '{Rest Days During Loan Period}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.loanPeriodRestDay',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-RestDaysAfterLoanPeriod',
    name: 'Rest Days After Loan Period',
    templatePreview: '{Rest Days After Loan Period}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.restDayAfterLoan',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-PublicHolidayBirthdayOff',
    name: 'Public Holiday / Birthday Off',
    templatePreview: '{Public Holiday / Birthday Off}',
    conditionType: 'set',
    fieldType: 'system',
    property: 'jobOfferInfo.holidayOffName',
    idProperty: 'jobOfferInfo.holidayOff',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-HousingType',
    name: 'Housing Type-Job Offer',
    templatePreview: '{Housing Type-Job Offer}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'jobOfferInfo.houseTypeSpecialName',
    idProperty: 'jobOfferInfo.houseType',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-NoOfBedrooms',
    name: 'No. of Bedrooms',
    templatePreview: '{No. of Bedrooms}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.roomCount',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-NoOfBathrooms',
    name: 'No. of Bathrooms',
    templatePreview: '{No. of Bathrooms}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.bathroomCount',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-TotalNoOfFamily',
    name: 'Total No. of Family',
    templatePreview: '{Total No. of Family}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.peopleCount',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-HaveChildren',
    name: 'Have Children',
    templatePreview: '{Have Children}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'jobOfferInfo.childCountName',
    idProperty: 'jobOfferInfo.childCount',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-NumberAgeOfChildren',
    name: 'Number & Age(s) of Children (if any)',
    templatePreview: '{Number & Age(s) of Children (if any)}',
    fieldType: 'system',
    property: 'jobOfferInfo.childAges',
    idProperty: 'jobOfferInfo.infantAges',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-NoOfPersonRequiringConstantCareAndAttention',
    name: 'No. of person(s) requiring constant care and attention (e.g., disabled, dementia, autism)',
    templatePreview: '{No. of person(s) requiring constant care and attention (e.g., disabled, dementia, autism)}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.constantCare',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-HavePets',
    name: 'Have Pets?',
    templatePreview: '{Have Pets?}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'jobOfferInfo.havePetsName',
    idProperty: 'jobOfferInfo.havePets',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-NumberAndTypeOfPets',
    name: 'Number and Type of pets',
    templatePreview: '{Number and Type of pets}',
    fieldType: 'system',
    property: 'jobOfferInfo.petInfo',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-WorkDuties',
    name: 'Work Duties',
    templatePreview: '{Work Duties}',
    conditionType: 'set',
    fieldType: 'system',
    property: 'jobOfferInfo.workDutyName',
    idProperty: 'jobOfferInfo.workDuty',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-AccommodationProvided',
    name: 'Accommodation Provided',
    templatePreview: '{Accommodation Provided}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'jobOfferInfo.accommodationProvided',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-RestDayGrantedOn',
    name: 'Rest Day Granted on',
    templatePreview: '{Rest Day Granted on}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'jobOfferInfo.restDayGrantedOn',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-ExpectedDeploymentDate',
    name: 'Expected Deployment Date',
    templatePreview: '{Expected Deployment Date}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'jobOfferInfo.expectedDeploymentDate',
    idProperty: 'jobOfferInfo.expectedDeploymentAsap',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-MeaslesDeclaration',
    name: 'Measles Declaration',
    templatePreview: '{Measles Declaration}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'jobOfferInfo.measlesDeclaration',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-Remark',
    name: 'Remark(for *Job Offer* only)',
    templatePreview: '{Remark(for *Job Offer* only)}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'jobOfferInfo.remark',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-ResidentialType',
    name: 'Residential Type',
    templatePreview: '{Residential Type}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'jobOfferInfo.residentialType',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'jobOffer-ResidentialSize',
    name: 'Residential Size(SQ.FEET)',
    templatePreview: '{Residential Size(SQ.FEET)}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.residentialSize',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'jobOffer-NoOfAdult',
    name: 'No. of Adult',
    templatePreview: '{No. of Adult}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.noOfAdult',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'jobOffer-NoOfChildren5To18',
    name: 'No. of Children(5-18 yo)',
    templatePreview: '{No. of Children(5-18 yo)}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.noOfChildrenLevelTwo',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'jobOffer-NoOfChildrenBelow5',
    name: 'No. of Children(<5 yo)',
    templatePreview: '{No. of Children(<5 yo)}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.noOfChildrenLevelOne',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'jobOffer-NoOfExpectedBaby',
    name: 'No. of Expected Baby',
    templatePreview: '{No. of Expected Baby}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.noOfNewBornBabyComing',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'jobOffer-ExpectedDateOfBirth',
    name: 'Expected Date of Birth',
    templatePreview: '{Expected Date of Birth}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'jobOfferInfo.newBornBabyComing',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'jobOffer-RoomSize',
    name: 'Room Size',
    templatePreview: '{Room Size}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.roomSize',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'jobOffer-SharedAge',
    name: 'Shared Age',
    templatePreview: '{Shared Age}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'jobOfferInfo.sharedAge',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'jobOffer-NoOfCurrentHelper',
    name: 'No. Of Current Helper',
    templatePreview: '{No. Of Current Helper}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'jobOfferInfo.noOfCurrentHelper',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'jobOffer-FacilitiesToBeProvidedToHelper',
    name: 'Facilities to be Provided to Helper',
    templatePreview: '{Facilities to be Provided to Helper}',
    conditionType: 'set',
    fieldType: 'system',
    property: 'jobOfferInfo.facilitiesToHelperList',
    specifyCountry: [1098],
    specifySide: ['agency'],
}, {
    key: 'jobOffer-OtherFacilitiesToBeProvidedToHelper',
    name: 'Other Facilities to be Provided to Helper',
    templatePreview: '{Other Facilities to be Provided to Helper}',
    conditionType: 'char',
    fieldType: 'system',
    property: 'jobOfferInfo.otherFacilitiesToHelper',
    specifyCountry: [1098],
    specifySide: ['agency'],
}]

export const feeBreakdownFieldList = [{
    key: 'feeBreakdown-InsuranceCompany',
    name: 'Insurance Company',
    templatePreview: '{Insurance Company}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'feeBreakdownInfo.insuranceCompanyName',
    idProperty: 'feeBreakdownInfo.insuranceCompany',
    specifySide: ['agency'],
}, {
    key: 'feeBreakdown-InsuranceCoveragePeriod',
    name: 'Insurance Coverage Period',
    templatePreview: '{Insurance Coverage Period}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'feeBreakdownInfo.insuranceCoveragePeriodName',
    idProperty: 'feeBreakdownInfo.insuranceCoveragePeriod',
    specifySide: ['agency'],
}, {
    key: 'feeBreakdown-InsurancePlanChosen',
    name: 'Insurance Plan Chosen',
    templatePreview: '{Insurance Plan Chosen}',
    conditionType: 'enum',
    fieldType: 'system',
    property: 'feeBreakdownInfo.insurancePlanName',
    idProperty: 'feeBreakdownInfo.insurancePlan',
    specifySide: ['agency'],
}, {
    key: 'feeBreakdown-InsuranceAddOns',
    name: 'Insurance Add-ons',
    templatePreview: '{Insurance Add-ons}',
    conditionType: 'set',
    fieldType: 'system',
    property: 'feeBreakdownInfo.insuranceAddOnsName',
    idProperty: 'feeBreakdownInfo.insuranceAddOns',
    extraProperty: 'feeBreakdownInfo.haveInsuranceAddOns',
    specifySide: ['agency'],
}, {
    key: 'feeBreakdown-InsuranceEffectiveDate',
    name: 'Insurance Effective Date',
    templatePreview: '{Insurance Effective Date}',
    conditionType: 'date',
    fieldType: 'system',
    property: 'feeBreakdownInfo.insuranceEffectiveDate',
    idProperty: 'feeBreakdownInfo.insuranceSameAsArrivalDate',
    valueFormat: 'date',
    specifySide: ['agency'],
}, {
    key: 'feeBreakdown-PackageFee',
    name: 'Package Fee',
    templatePreview: '{Package Fee}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'feeBreakdownInfo.packageFee',
    valueFormat: 'money',
    specifySide: ['agency'],
}, {
    key: 'feeBreakdown-ServiceFee',
    name: 'Service Fee',
    templatePreview: '{Service Fee}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'feeBreakdownInfo.serviceFee',
    valueFormat: 'money',
    specifySide: ['agency'],
}, {
    key: 'feeBreakdown-NonServiceFee',
    name: 'Non-Service Fee',
    templatePreview: '{Non-Service Fee}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'feeBreakdownInfo.nonServiceFee',
    valueFormat: 'money',
    specifySide: ['agency'],
}, {
    key: 'feeBreakdown-PackageFeeDeposit',
    name: 'Package Fee Deposit',
    templatePreview: '{Package Fee Deposit}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'feeBreakdownInfo.packageFeeDeposit',
    valueFormat: 'money',
    specifySide: ['agency'],
}, {
    key: 'feeBreakdown-PackageFeeBalance',
    name: 'Package Fee Balance',
    templatePreview: '{Package Fee Balance}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'feeBreakdownInfo.packageFeeBalance',
    valueFormat: 'money',
    specifySide: ['agency'],
}, {
    key: 'feeBreakdown-PlacementFee',
    name: 'Placement Fee',
    templatePreview: '{Placement Fee}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'feeBreakdownInfo.placementFee',
    valueFormat: 'money',
    specifySide: ['agency'],
}, {
    key: 'feeBreakdown-AdHocArrangement',
    name: 'Ad Hoc Arrangement',
    templatePreview: '{Ad Hoc Arrangement}',
    conditionType: 'number',
    fieldType: 'system',
    property: 'feeBreakdownInfo.adHocArrangementFee',
    valueFormat: 'money',
    specifyCountry: [1098],
    specifySide: ['agency'],
}]

export const otherFieldList = [{
    key: 'other-CurrentDate',
    name: 'Current Date',
    templatePreview: '{Current Date}',
    fieldType: 'currentDate',
    conditionType: 'date',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'other-CurrentMonth',
    name: 'Current Month(numeric)',
    templatePreview: '{Current Month(numeric)}',
    fieldType: 'currentMonth',
    conditionType: 'number',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'other-CurrentMonthSpelledOut',
    name: 'Current Month(spelled out)',
    templatePreview: '{Current Month(spelled out)}',
    fieldType: 'currentMonthSpelledOut',
    conditionType: 'char',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'other-CurrentDay',
    name: 'Current Day',
    templatePreview: '{Current Day}',
    fieldType: 'currentDay',
    conditionType: 'number',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'other-CurrentYear',
    name: 'Current Year',
    templatePreview: '{Current Year}',
    fieldType: 'currentYear',
    conditionType: 'number',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'other-FirstSignerTimeStamp',
    name: 'Time Stamp - First Signer',
    templatePreview: '{Time Stamp - First Signer}',
    fieldType: 'SignTimeStamp',
    conditionType: 'char',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'other-EmployerTimeStamp',
    name: 'Time Stamp - Employer',
    templatePreview: '{Time Stamp - Employer}',
    fieldType: 'SignTimeStamp',
    conditionType: 'char',
    property: 'signatureImgPath.sign_employer.signTimeStr',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'other-HelperTimeStamp',
    name: 'Time Stamp - Helper',
    templatePreview: '{Time Stamp - Helper}',
    fieldType: 'SignTimeStamp',
    conditionType: 'char',
    property: 'signatureImgPath.sign_helper.signTimeStr',
    specifySide: ['agency', 'supplier'],
}, {
    key: 'other-AgencyTimeStamp',
    name: 'Time Stamp - Agency',
    templatePreview: '{Time Stamp - Agency}',
    fieldType: 'SignTimeStamp',
    conditionType: 'char',
    property: 'signatureImgPath.sign_agency.signTimeStr',
    specifySide: ['agency'],
}, {
    key: 'other-ProxyForeignAgencyTimeStamp',
    name: 'Time Stamp - Foreign Processing Service Agency',
    templatePreview: '{Time Stamp - Foreign Processing Service Agency}',
    fieldType: 'SignTimeStamp',
    conditionType: 'char',
    property: 'signatureImgPath.sign_proxy_agency.signTimeStr',
    specifySide: ['supplier'],
}, {
    key: 'other-IPAAgencyTimeStamp',
    name: 'Time Stamp - IPA Agency',
    templatePreview: '{Time Stamp - IPA Agency}',
    fieldType: 'SignTimeStamp',
    conditionType: 'char',
    property: 'signatureImgPath.sign_ipa_agency.signTimeStr',
    specifySide: ['agency'],
}, {
    key: 'other-Sponsor1TimeStamp',
    name: 'Time Stamp - Sponsor1',
    templatePreview: '{Time Stamp - Sponsor1}',
    fieldType: 'SignTimeStamp',
    conditionType: 'char',
    property: 'signatureImgPath.sign_sponsor_1.signTimeStr',
    specifySide: ['agency'],
}, {
    key: 'other-Sponsor2TimeStamp',
    name: 'Time Stamp - Sponsor2',
    templatePreview: '{Time Stamp - Sponsor2}',
    fieldType: 'SignTimeStamp',
    conditionType: 'char',
    property: 'signatureImgPath.sign_sponsor_2.signTimeStr',
    specifySide: ['agency'],
}]
